var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOfficeAsset = function SvgOfficeAsset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "office-asset_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#office-asset_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.746 3.14v.972h-.899v15.8H7.505v.923h8.99v-.923h-1.354v-1.354h-2.098v-.852l.048-.036h2.05v-.899h-3.273v-.887h3.273v-.923h-3.68v-.887h3.68V11.22H9.746v-.803h5.395v-.983H9.746V8.63h5.395v-.983H9.746v-.755l.036-.048h5.359v-.947H9.782l-.036-.048v-.755h5.395v-.983h-.947V3.14H9.746Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "office-asset_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgOfficeAsset as ReactComponent };